import { useTranslation } from 'react-i18next';
import { usePortfolio } from '../../hooks/usePortfolio';

interface CertItem {
  name: string;
  issuer: string;
  year: number;
}

interface SkillItem {
  name: string;
  category: string;
  level: number;
}

export function Skills() {
  const { t } = useTranslation();
  const { data: certs, loading: certsLoading } = usePortfolio<CertItem>('CERTIFICATION');
  const { data: skills, loading: skillsLoading } = usePortfolio<SkillItem>('SKILL');

  const categories = [...new Set(skills.map((s) => s.category))];

  return (
    <section id="skills" className="bg-bg-surface py-24 px-6">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-mono text-sm text-accent">{`// ${t('nav.skills')}`}</h2>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          <div>
            <h3 className="text-lg font-semibold">Certifications</h3>
            <div className="mt-4 space-y-3">
              {certsLoading ? (
                <div className="h-20 animate-pulse rounded border border-border bg-bg-primary" />
              ) : (
                certs.map((cert, idx) => (
                  <div key={idx} className="rounded border border-border p-3">
                    <p className="text-sm font-medium">{cert.name}</p>
                    <p className="font-mono text-xs text-text-muted">{cert.issuer} · {cert.year}</p>
                  </div>
                ))
              )}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold">Tech Stack</h3>
            <div className="mt-4 space-y-6">
              {skillsLoading ? (
                <div className="h-20 animate-pulse rounded border border-border bg-bg-primary" />
              ) : (
                categories.map((cat) => (
                  <div key={cat}>
                    <p className="font-mono text-xs text-text-muted uppercase">{cat}</p>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {skills
                        .filter((s) => s.category === cat)
                        .map((skill, idx) => (
                          <span
                            key={idx}
                            className="border border-border px-2 py-1 font-mono text-xs text-text-primary transition-colors hover:border-accent hover:text-accent"
                          >
                            {skill.name}
                          </span>
                        ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
